import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
    addSwatchButton: {
        height: '23px',
        width: '23px',
        minWidth: '23px',
        borderRadius: '3px',
        padding: '3px',
        '& svg': {
            height: '17px',
            width: '17px'
        }
    },
}))

export default useStyles